module.exports = __webpack_public_path__ + "img/chinesecompany188.a05fb748.png";